import Preview from '../Preview'
import FieldEdit from '../FieldEdit'
import FundraiseUpForm from './FundraiseUpForm'

export default function FundraiseUpActionView({ actionId }) {
  const templateFields = useSel(s => s.builder.flow.templateFields)
  const flowFields = useSel(s => s.builder.flow.flowFields)
  const selectedActionId = useSel(s => s.local.selectedActionId)
  const config = useSel(s => s.actions.entities[selectedActionId]?.config || {})
  const context = { template: templateFields, embedUrl: config?.embedUrl, flow: { ...flowFields, current_action_kind: 'lunda' }, client: { brand: JSON.parse(window.ENV.CLIENT_BRAND)} }
  const action = useSel(s => s.actions.entities[actionId] || {})

  const componentMap = useMemo(() => ({
    TakeSurveyForm: <>
    <FundraiseUpForm
      action={action}
      onSubmit={() => Promise.resolve()}
    />
    </>,
    FieldEdit,
  }), [JSON.stringify(config)])

  return <Preview context={context} componentMap={componentMap} />
}
